import { Button, IconButton } from '@chr/eds-react';
import { Box, List, ListItem, Modal } from '@mui/material';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import WhatsNewGif from './uat-gif-bookingdetails-sm.gif';
import React from 'react';

export type WhatsNewModalProps = {
  closeWhatsNewModal: () => void,
  isModalOpen: boolean;
};

const textToDisplay = [
  "Bookings now display risk level (based on account setup).",
  "Upload, download and share booking documents.",
  "Review booking progress stop by stop.",
  "And more!"
];

const getModalContent = (content: string, key: number) => {
  return (
    <ListItem key={key} sx={{ display: 'list-item' }}>
      {content}
    </ListItem>
  );
};

const WhatsNewModal = (props: WhatsNewModalProps) => {
  const translate = useTranslation();

  return (
    <Modal
      open={props.isModalOpen}
      sx={{
        overflow: 'scroll',
      }}
    >
      <Box
        sx={{
          marginY: '45px',
          padding: '24px',
          position: 'absolute',
          left: '50%',
          transform: 'translate(-50%, 0%)',
          bgcolor: 'background.paper',
          borderRadius: '4px',
          background: 'var(--neutral-white-ffffff, #FFF)',
          boxShadow: '0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.20)'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            '.MuiIcon-root': {
              fontSize: '24px',
              color: '#111112',
            },
          }}
        >
          <IconButton
            aria-label="whats-new-modal-close-icon-button"
            icon="close"
            onClick={props.closeWhatsNewModal}
            variant="tertiary"
          />
        </Box>
        <Box fontSize="16px" paddingBottom='24px'>
          {translate("See what’s new with booking details")}
        </Box>
        <img src={WhatsNewGif} alt="what's new gif" />
        <Box paddingTop="24px">
          {translate("Introducing the updated booking details page.")}
        </Box>
        <List sx={{ listStyleType: 'disc', paddingLeft: '24px' }}>
          {textToDisplay.map((text, i) =>
            getModalContent(translate(text), i)
          )}
        </List>
        <Box paddingTop='16px' paddingBottom='24px'>
          {translate("Need help? Connect with your account expert.")}
        </Box>
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="flex-start"
          alignSelf="stretch"
        >
          <Button onClick={props.closeWhatsNewModal} buttonText={translate('Close')} />
        </Box>
      </Box>
    </Modal>
  );
};

export default WhatsNewModal;
